import { Bookmark } from "lucide-react";
import { toast } from "sonner";
import { useVisitor } from "@/lib/visitor";

/** Shortlist toggle. Saved profiles live only on the visitor's device - LUX keeps no record. */
export default function SaveButton({ slug, name, size = "icon", className = "", testId = "save-profile-button" }) {
  const { isSaved, toggleSaved } = useVisitor();
  const saved = isSaved(slug);
  const onClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    const now = toggleSaved(slug);
    toast(now ? `${name} saved to your shortlist` : `${name} removed from your shortlist`, { description: "Saved on this device only." });
  };
  if (size === "button") {
    return (
      <button onClick={onClick} aria-pressed={saved} className={`lux-btn lux-btn-secondary ${className}`} data-testid={testId}>
        <Bookmark className={`h-4 w-4 ${saved ? "fill-current" : ""}`} aria-hidden="true" /> {saved ? "Saved" : "Save"}
      </button>
    );
  }
  return (
    <button onClick={onClick} aria-pressed={saved} aria-label={saved ? `Remove ${name} from shortlist` : `Save ${name} to shortlist`}
      className={`inline-flex h-9 w-9 items-center justify-center rounded-full border border-lux-border bg-black/55 text-lux-silver backdrop-blur hover:border-lux-silver/60 hover:text-lux-silverBright ${saved ? "text-lux-silverBright" : ""} ${className}`}
      data-testid={testId}>
      <Bookmark className={`h-4 w-4 ${saved ? "fill-current" : ""}`} aria-hidden="true" />
    </button>
  );
}
